export interface BlogPost {
  slug: string;
  title: string;
  excerpt: string;
  category: string;
  date: string;
  markdownFile: string;
}

export const blogPosts: BlogPost[] = [
  {
    slug: "how-much-do-musicians-earn-india",
    title: "How Much Do Independent Musicians Earn in India? (2025 Reality + My Experience)",
    excerpt: "Some believe only Bollywood singers make money. Others think independent music is a hobby, not a career. The truth is more interesting — and more empowering — than both these extremes.",
    category: "Songwriting",
    date: "Dec 10, 2025",
    markdownFile: "how-much-do-musicians-earn-india.md"
  },
  {
    slug: "music-production-basics",
    title: "Music Production Basics for Indie Artists",
    excerpt: "Learn the essential production techniques to create professional-sounding tracks from home.",
    category: "Production",
    date: "Dec 8, 2025",
    markdownFile: "music-production-basics.md"
  },
  {
    slug: "launching-your-music-guide",
    title: "Launching Your Music: A Step-by-Step Guide",
    excerpt: "Everything you need to know about releasing your music on streaming platforms and building an audience.",
    category: "Launch",
    date: "Dec 5, 2025",
    markdownFile: "launching-your-music-guide.md"
  },
  {
    slug: "overcoming-creative-blocks",
    title: "Overcoming Creative Blocks in Music",
    excerpt: "Practical strategies to stay inspired and keep creating even when motivation runs low.",
    category: "Mindset",
    date: "Dec 1, 2025",
    markdownFile: "overcoming-creative-blocks.md"
  }
];
